import React from 'react';
// We'll import withRouter instead of useParams, my dear
import { withRouter } from 'react-router-dom'; 
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import BlogDetailsPage from '../../components/BlogDetailsPage/BlogDetailsPage';
import { Helmet } from 'react-helmet';

// The component will now receive 'props' from withRouter
function BlogDetails(props) {
  // The blogId is now inside props.match.params
  const { blogId } = props.match.params;

  return (
    <div>
      <Helmet>
        <title>MPLOI Blog</title>
      </Helmet>
      <Header />
      {/* We pass the blogId down just like before */}
      <BlogDetailsPage blogId={blogId} />
      <Footer />
    </div>
  );
}

// Here's the magic: we wrap our component with withRouter before exporting it
export default withRouter(BlogDetails);